var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPentagon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15.432436,
    viewBox: "0 0 16 15.432436",
    fill: "none",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 6.7041323,0.42104582 c 0.7726973,-0.56139508 1.8190035,-0.5613941 2.5916808,10e-7 L 15.091043,4.6315074 c 0.772698,0.561396 1.096043,1.5564962 0.800917,2.4648515 L 13.678318,13.90899 c -0.295126,0.908404 -1.141605,1.523446 -2.096747,1.523446 H 4.4183454 c -0.9551033,0 -1.8015821,-0.615042 -2.096718,-1.523446 L 0.10805238,7.0963589 c -0.29514273,-0.9083553 0.028184,-1.9034555 0.8008793,-2.4648515 z",
    fill: "currentColor",
    id: "path1",
    style: {
      strokeWidth: 0.979834
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPentagon);
export default __webpack_public_path__ + "static/media/pentagon.3f6aec01139d552ce4bcab528dffb656.svg";
export { ForwardRef as ReactComponent };